/**
 * AdminShell — the chrome around every authenticated screen.
 *
 * Layout:
 *   ┌─────────────┬──────────────────────────────┐
 *   │             │  Topbar  (user, logout)      │
 *   │  Sidebar    ├──────────────────────────────┤
 *   │             │                              │
 *   │             │  <Outlet />                  │
 *   │             │                              │
 *   └─────────────┴──────────────────────────────┘
 */
import { Outlet } from "react-router-dom";

import { Sidebar } from "./Sidebar";
import { Topbar } from "./Topbar";

export function AdminShell() {
  return (
    <div className="flex h-full w-full bg-stone-100">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <Topbar />
        <main className="flex-1 overflow-auto p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
